export default "__VITE_ASSET__YUa7FYAp__"